import React, { useState } from "react";
import ListGroup from "../../atoms/listGroup";
import { DUMMY_DATA } from "../../pages/privateDashboard/businessDashboard/BusinessCategory/screen";
import { DUMMY_DATA_BUSINESS_UNIT } from "../../pages/privateDashboard/businessDashboard/BussinessUnit/screen";

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const FormCreateRevenue = ({submitHandler}) => {
  const [selectedCatgory, setSelectedCategory] = useState("");
  const [name, setName] = useState("");
  const getNewDate = new Date();
  const submitRevenueHandler = (e) => {
    e.preventDefault();
    const data = {
      id: DUMMY_DATA_BUSINESS_UNIT.length + 1,
      name: name,
      category: DUMMY_DATA.find(el => el.id === +selectedCatgory),
      establishDate: `${getNewDate.getDate()} ${monthNames[getNewDate.getMonth()]} ${getNewDate.getFullYear()}`
    }
    submitHandler(data);
  };
  const selectedCategoryHandler = (value) => {
    setSelectedCategory(value);
  }
  const newOptions = DUMMY_DATA.map(el => {
    return { value: el.id, label: el.name }
  });
  return (
    <>
      <form onSubmit={submitRevenueHandler}>
        <div className="group-input">
          <label htmlFor="category">Kategori Business Unit</label>
          <ListGroup
            option={newOptions}
            selectedCategoryHandler={selectedCategoryHandler}
          />
        </div>
        <div className="group-input">
          <label htmlFor="business">Business Unit</label>
          <input
            type="text"
            className="rounded-lg"
            required={true}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g Digital Corporation"
          />
        </div>
        <div className="btn-group">
          <button
            type="submit"
            className="mx-auto border-2 p-2 w-[150px] rounded-lg btn-save bg-gray-50 hover:bg-white"
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default FormCreateRevenue;
